import API from '../api/api'
import { deepMerge } from '../helper'
import { refreshAvailableWords } from './shop'

const GET_PLANS_PENDING = 'GET_PLANS_PENDING';
const GET_PLANS_RESPONSE = 'GET_PLANS_RESPONSE';
const CHANGE_PLAN_PENDING = 'CHANGE_PLAN_PENDING';
const CHANGE_PLAN_RESPONSE = 'CHANGE_PLAN_RESPONSE';
const REDEEM_DISCOUNT_PENDING = 'REDEEM_DISCOUNT_PENDING';
const REDEEM_DISCOUNT_RESPONSE = 'REDEEM_DISCOUNT_RESPONSE';
const REMOVE_DISCOUNT_PENDING = 'REMOVE_DISCOUNT_PENDING';
const REMOVE_DISCOUNT_RESPONSE = 'REMOVE_DISCOUNT_RESPONSE';
const RESET_DISCOUNT_ERROR = 'RESET_DISCOUNT_ERROR';

const initialState = {
	get_plans_pending: false,
  change_plan_pending: false,
	availablePlans: null,
	plans: [],
  featureList: [],
  // pending discount code (GET plans -> discount): null | {code, rules, expires_at, preview}
  discount: null,
  // discount of the running subscription (GET plans -> current_discount, live from Shopify):
  // null | {status, type: percentage|amount, value, duration_limit, remaining, price, price_after_discount}
  current_discount: null,
  discount_pending: false,
  // null | {error: invalid|expired|used|in_use|not_eligible|rate_limited|plan_not_allowed|network|unknown, retry_after?, allowed_plans?}
  discount_error: null,
}


const updateFeaturesWithPlans = (features, plans) => {
  // Clone the features object to avoid mutating the original
  let updatedFeatures = JSON.parse(JSON.stringify(features));

  // Iterate over each plan
  plans.forEach(plan => {
    // Find the feature list for the current plan
    let featureList = updatedFeatures[plan.key];

    // Update the feature list with the plan properties
    featureList.forEach(feature => {
      if (plan.hasOwnProperty(feature.key)) {
        feature.value = plan[feature.key];
      }
    });
  });
  return updatedFeatures;
}
let list = [
  { "key": "languages", "name": "Languages", "value": 5, "tease": true },
  { "key": "support_24_7", "name": "24/7 Support", "value": true, "tease": true },
  { "key": "seo", "name": "SEO", "value": true, "tease": true },
  { "key": "manual_translations", "name": "Manual Translation", "value": "unlimited", "tease": true },
  { "key": "checkout_translation", "name": "Checkout Translation", "value": true, "tease": false },
  { "key": "auto_translations", "name": "Machine Translation", "value": false, "tease": true },
  { "key": "bulk_translations", "name": "Bulk Translations", "value": false, "tease": true },
  { "key": "onetime_words", "name": "Free Machine-translation words", "value": 10000, "tease": true },
  { "key": "import_export", "name": "Import & Export", "value": false, "tease": true },
  { "key": "max_word_discount", "name": "Maximum word discount", "value": 0, "tease": true },
  { "key": "custom_content", "name": "Custom Content Feature", "value": false, "tease": true },
  { "key": "crossdomain_switcher", "name": "Switcher Configurator", "value": false, "tease": true },
  { "key": "country_currency", "name": "Country & Currency Switcher", "value": false, "tease": false },
  { "key": "language_detection", "name": "Language Detection", "value": false, "tease": false },
  { "key": "image_translation", "name": "Image Translations", "value": false, "tease": false },
  { "key": "analytics_dashboard", "name": "Analytics", "value": true, "tease": false },
  { "key": "priority_support", "name": "Priority Support", "value": false, "tease": true },
  { "key": "available_words_log", "name": "Wordslog timespan", "value": 0, "tease": false },
  { "key": "glossary_entries", "name": "Glossary Entries", "value": 3, "tease": true },
]
let features = {
  "Free": list.slice(),
  "Basic": list.slice(),
  "Growth": list.slice(),
  "Premium": list.slice(),
};



// REDUCER
export default (state = initialState, action) => {
	switch(action.type) {

		case GET_PLANS_PENDING: {
			return {
				...state,
				get_plans_pending: true,
			}
		}
		case GET_PLANS_RESPONSE: {
			if(action.response.success === true) {
				const newPlans = action.response.plans.slice();
        const newFeaturesList = updateFeaturesWithPlans(features, newPlans);
				return {
					...state,
          get_plans_pending: false,
					plans: newPlans,
          featureList: newFeaturesList,
          discount: action.response.discount || null,
          current_discount: action.response.current_discount || null,
				}
			} else {
        return {
          ...state,
          get_plans_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
			}
		}


		case CHANGE_PLAN_PENDING: {
			return {
				...state,
        change_plan_pending: true,
			}
		}
		case CHANGE_PLAN_RESPONSE: {
      const response = action.response || {};
			return {
				...state,
        change_plan_pending: false,
        discount_error: response.error === 'plan_not_allowed' || response.error === 'code_in_use'
          ? { error: response.error, allowed_plans: response.allowed_plans || [] }
          : state.discount_error,
			}
		}

    case REDEEM_DISCOUNT_PENDING: {
      return {
        ...state,
        discount_pending: true,
        discount_error: null,
      }
    }
    case REDEEM_DISCOUNT_RESPONSE: {
      const response = action.response || {};
      if(response.success === true) {
        return {
          ...state,
          discount_pending: false,
          discount_error: null,
          discount: {
            code: response.code,
            rules: response.rules,
            expires_at: response.expires_at,
            preview: response.preview,
          },
        }
      }
      return {
        ...state,
        discount_pending: false,
        discount_error: {
          error: response.error || 'unknown',
          retry_after: response.retry_after || null,
          allowed_plans: response.allowed_plans || null,
        },
      }
    }

    case REMOVE_DISCOUNT_PENDING: {
      return {
        ...state,
        discount_pending: true,
      }
    }
    case REMOVE_DISCOUNT_RESPONSE: {
      const response = action.response || {};
      if(response.success === true) {
        return {
          ...state,
          discount_pending: false,
          discount_error: null,
          discount: null,
          plans: state.plans.map(plan => ({ ...plan, discount: null })),
        }
      }
      return {
        ...state,
        discount_pending: false,
        discount_error: { error: response.error || 'unknown' },
      }
    }

    case RESET_DISCOUNT_ERROR: {
      return {
        ...state,
        discount_error: null,
      }
    }


		default:
			return state
	}
}



export const getPlans = (callback) => { 
	return dispatch => {
		dispatch({
			type: GET_PLANS_PENDING,
		})

		API.getPlans(
			response => {
				dispatch({
					type: GET_PLANS_RESPONSE,
					response: response,
					action: () => getPlans(callback)
				});
				if(callback) {
					callback(response);
				}
		})
	}
}

// The callback only runs when the API does not redirect to the Shopify confirmation page.
export const changePlan = (newPlan, callback) => {  
	return dispatch => {
		dispatch({
			type: CHANGE_PLAN_PENDING,
		});

		API.changePlan(
			newPlan,
			response => {
				dispatch({
					type: CHANGE_PLAN_RESPONSE,
					response: response,
					action: () => changePlan(newPlan, callback)
				});
				if(callback) {
					callback(response);
				}
		})
	}
}

// After a successful redeem the plans are reloaded, they carry the discounted price per plan.
export const redeemDiscount = (code, callback) => {
  return dispatch => {
    dispatch({
      type: REDEEM_DISCOUNT_PENDING,
    });

    API.redeemDiscount(
      code,
      response => {
        dispatch({
          type: REDEEM_DISCOUNT_RESPONSE,
          response: response,
        });
        if(response && response.success === true) {
          dispatch(getPlans());
          // instant words code: the words are on the account already
          if(response.words_credited) {
            dispatch(refreshAvailableWords());
          }
        }
        if(callback) {
          callback(response);
        }
    })
  }
}

export const removeDiscount = (callback) => {
  return dispatch => {
    dispatch({
      type: REMOVE_DISCOUNT_PENDING,
    });

    API.removeDiscount(
      response => {
        dispatch({
          type: REMOVE_DISCOUNT_RESPONSE,
          response: response,
        });
        if(response && response.success === true) {
          dispatch(getPlans());
        }
        if(callback) {
          callback(response);
        }
    })
  }
}

export const resetDiscountError = () => ({ type: RESET_DISCOUNT_ERROR });
